import { useSyncExternalStore } from "react";

import { portalLanguagePick } from "./portal-language-pick";

export const usePortalLanguagePick = () =>
  useSyncExternalStore(portalLanguagePick.subscribe, portalLanguagePick.get);
